import type { MessageModel } from "../../api/api";

export type DisplayChatMessage = MessageModel & { clientMessageId?: string; pendingSend?: boolean };
export function chatMessageDisplayId(message: MessageModel): string {
  return (message as DisplayChatMessage).clientMessageId ?? message.id;
}

/** Preserve unchanged message identities so polls do not remount attachment previews. */
export function mergeMessages(existing: MessageModel[], incoming: MessageModel[], prepend = false): MessageModel[] {
  if (incoming.length === 0) return existing;
  const prior = new Map(existing.map((message) => [message.id, message]));
  const changed = incoming.map((message) => {
    const old = prior.get(message.id);
    return old && JSON.stringify(old) === JSON.stringify(message) ? old : message;
  });
  const updates = new Map(changed.map((message) => [message.id, message]));
  const result = prepend
    ? [...changed, ...existing.filter((message) => !updates.has(message.id))]
    : [...existing.map((message) => updates.get(message.id) ?? message), ...changed.filter((message) => !prior.has(message.id))];
  return result.length === existing.length && result.every((message, index) => message === existing[index]) ? existing : result;
}
